export default __webpack_public_path__ + "static/media/node.18fe5d93.svg";